export const VERSION = '2.42.4';
